import { useAppSelector } from 'hooks/reduxHooks'
import type { PropsWithChildren } from 'react'
import { createContext } from 'react'
import ModalProvider from './ModalProvider'

const CurrencyContext = createContext<string>('AUD')

interface Props {
  currency?: string
}

export function CurrencyProvider(props: PropsWithChildren<Props>) {
  const currentCurrency = useAppSelector((state) => state.geo.currentCurrency)

  // we use 'or' in case currency is an empty string
  return <CurrencyContext.Provider value={props.currency || currentCurrency}>
    <ModalProvider>
      {props.children}
    </ModalProvider>
  </CurrencyContext.Provider>
}

export default CurrencyContext
